export default __webpack_public_path__ + "static/media/Бор+Моліб_20л.ca6728d5.jpg";